<app-retail-store-form-wrapper
  data-testid="retail-store-view-container"
  [config]="config"
  [editMode]="false"
  [viewMode]="true"
></app-retail-store-form-wrapper>